import React from 'react';
import { brandByKey, brands, criteria } from '../../data/strategy';
import { BrandLegend } from '../deck/BrandLegend';
import { PerceptionChart, type ChartRow } from '../deck/PerceptionChart';
import { SlideFrame, SlideTitle } from '../deck/SlideFrame';
const rows: ChartRow[] = criteria.map(criterion => ({
  label: criterion.label,
  points: brands.map(brand => ({
    key: brandByKey[brand.key].name,
    value: criterion.hcp[brand.key],
    color: brand.color
  }))
}));
export function HcpPerceptionSlide() {
  return <SlideFrame marker="Step 02 — HCP perception" data-id="element-111" data-mp="eh53xjuc20ai">
      <SlideTitle sub="Read it row by row. On efficacy the HCP puts Dovobet ahead of us; on speed and patient experience we lead, but only just." data-id="element-112" data-mp="s6yqfvid88h2">
        How HCPs rate the options today
      </SlideTitle>

      <div className="mt-[3vh] flex min-h-0 flex-1 gap-[4%]" data-id="element-113" data-mp="3vvtob448k9rp">
        <div className="min-h-0 flex-1 pb-[1vh]" data-id="element-114" data-mp="3vu8rt8yd2gr7">
          <PerceptionChart rows={rows} axisLabel="Perceived strength (1 = weaker → 5 = stronger)" highlightKey="ROCHE" labelWidth="26%" data-id="element-115" data-mp="3qy0iwdarbjsh" />
        </div>
        <aside className="flex w-[26%] flex-col justify-center gap-[2.4vh] border-l border-ink-line pl-[4%]" data-id="element-116" data-mp="1k34wnww3cnnp">
          <div data-id="element-117" data-mp="1ow7tqf02uf8n">
            <p className="text-[clamp(9px,1vw,16px)] font-semibold uppercase tracking-[0.12em] text-gapAccent" data-id="element-118" data-mp="1ovohnex3yl2j">
              Where we sit
            </p>
            <p className="mt-[1vh] text-[clamp(11px,1.22vw,20px)] leading-[1.45] text-ink-soft" data-id="element-119" data-mp="w70u1covzjlt">
              Mid-field on the criterion that carries most weight, and clustered
              with the generic on long-term control.
            </p>
          </div>
          <div data-id="element-120" data-mp="166rmz9xstqjs">
            <p className="text-[clamp(9px,1vw,16px)] font-semibold uppercase tracking-[0.12em] text-ink-mute" data-id="element-121" data-mp="1a5qritfmblap">
              What that means
            </p>
            <p className="mt-[1vh] text-[clamp(11px,1.22vw,20px)] leading-[1.45] text-ink-soft" data-id="element-122" data-mp="2hjam0pe5ttqg">
              Nothing yet. A rating is only a problem once we compare it with
              what we can defend.
            </p>
          </div>
        </aside>
      </div>

      <BrandLegend variant="bar" className="mt-[2.4vh] shrink-0" data-id="element-123" data-mp="hi443d0a9zp0" />
    </SlideFrame>;
}